import React from 'react'
import { Layout, Menu, Avatar, Dropdown, Space } from 'antd'
import {
  DashboardOutlined,
  UserOutlined,
  ShoppingCartOutlined,
  AccountBookOutlined,
  SettingOutlined,
  LogoutOutlined,
  CloudUploadOutlined
} from '@ant-design/icons'
import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

const { Header, Sider, Content } = Layout

const menuItems = [
  {
    key: '/dashboard',
    icon: <DashboardOutlined />,
    label: '仪表盘'
  },
  {
    key: '/users',
    icon: <UserOutlined />,
    label: '用户管理'
  },
  {
    key: '/orders',
    icon: <ShoppingCartOutlined />,
    label: '订单管理'
  },
  {
    key: '/ledger',
    icon: <AccountBookOutlined />,
    label: '账本管理'
  },
  {
    key: '/configs',
    icon: <SettingOutlined />,
    label: '系统配置'
  },
  {
    key: '/seed-import',
    icon: <CloudUploadOutlined />,
    label: '数据导入'
  }
]

const MainLayout: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user, logout, isAdmin } = useAuth()

  const visibleMenuItems = menuItems.filter((item) => {
    if (item.key === '/configs' || item.key === '/seed-import') {
      return isAdmin
    }
    return true
  })

  const handleMenuClick = ({ key }: { key: string }) => {
    navigate(key)
  }

  const handleLogout = () => {
    logout()
  }

  const dropdownItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout
    }
  ]

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        theme="dark"
        width={200}
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0
        }}
      >
        <div style={{
          height: 64,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontSize: 20,
          fontWeight: 'bold'
        }}>
          📋 这单买不买
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={visibleMenuItems}
          onClick={handleMenuClick}
        />
      </Sider>

      <Layout style={{ marginLeft: 200 }}>
        <Header style={{
          background: '#fff',
          padding: '0 24px',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          boxShadow: '0 1px 4px rgba(0, 0, 0, 0.08)'
        }}>
          <Dropdown menu={{ items: dropdownItems }}>
            <Space style={{ cursor: 'pointer' }}>
              <Avatar icon={<UserOutlined />} src={user?.avatar_url} />
              <span>{user?.nickname || '管理员'}</span>
            </Space>
          </Dropdown>
        </Header>

        <Content style={{
          margin: 24,
          padding: 24,
          background: '#fff',
          borderRadius: 8,
          minHeight: 280
        }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  )
}

export default MainLayout
